import {
  SET_INITIAL_MEMBER_STATE,
  RESET_BOOK_RESPONSE,
  RESET_FORM_TYPE,
  SET_POSTAL_BTN_ENABLE,
  SET_DC_LIST,
  SET_INCLUDED_MEMBER,
  SET_SHOW_VISIT_TYPE,
  SET_TPA_DETAILS,
  SET_VISIT_TYPE,
  SET_SELECTED_CENTER_TYPE,
  SET_PINCODE,
  SET_APPOINTMENT_DATE_TYPE,
  SET_MOBILE_TYPE,
  SET_EMAIL_TYPE,
  SET_CITY_TYPE,
  SET_ADDRESS_TYPE,
  SET_APPOINTMENT_TIME_TYPE,
  SET_IS_MODAL_OPEN_TYPE,
  SET_ERROR_TYPE,
  SET_HOME_PINCODE_TYPE
} from "./types";

const initialFormObj = {
  dcList: null,
  selectedCenter: null,
  appointmentDate: null,
  mobile: "",
  email: "",
  address: {
    line1: "",
    line2: "",
    landmark: "",
  },
  city: "",
  homePincode: "",
  appointmentTime: {
    hour: "07",
    minute: "00",
    meridiem: "AM",
  },
  errors: {}
}

const initialMemberState = {
  visitType: null,
  isPostalBtnEnable: false,
  includedMembers: [],
  pinCode: "",
  tpaDetails: null,
  showVisitType: false,
  isModalOpen: false,
  ...initialFormObj
}

const initialState = {
  Application_Number: ""
};

const bookVisitReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_INITIAL_MEMBER_STATE:
      return { 
        ...state,
          Application_Number:  payload?.applicationNumber,
          [payload?.memberId] : {...(state[payload?.memberId] ? state[payload?.memberId] : initialMemberState), includedMembers: state[payload?.memberId]?.includedMembers ? state[payload?.memberId]?.includedMembers : [payload?.memberId]}
        }
    case SET_PINCODE: 
      return { 
        ...state,
          [payload?.memberId] : {...state[payload?.memberId], pinCode: payload?.pinCode}
        }
    case SET_HOME_PINCODE_TYPE: 
      return { 
        ...state,
          [payload?.memberId] : {...state[payload?.memberId], homePincode: payload?.value}
        }
    case SET_POSTAL_BTN_ENABLE:
      return { 
        ...state,
          [payload?.memberId] : {...state[payload?.memberId], isPostalBtnEnable: payload?.value}
        }
      case SET_SHOW_VISIT_TYPE:
        return { 
          ...state,
            [payload?.memberId] : {...state[payload?.memberId], showVisitType: payload?.value}
          }
      case SET_VISIT_TYPE:
        return { 
          ...state,
            [payload?.memberId] : {...state[payload?.memberId], visitType: payload?.value}
          }
      case SET_TPA_DETAILS:
        return { 
          ...state,
            [payload?.memberId] : {...state[payload?.memberId], tpaDetails: payload?.value}
          }
      case SET_DC_LIST:
        return { 
          ...state,
            [payload?.memberId] : {...state[payload?.memberId], dcList: payload?.value}
          }
      case SET_INCLUDED_MEMBER:
        return { 
          ...state,
            [payload?.memberId] : {...state[payload?.memberId], includedMembers: payload?.value}
          }
      case SET_SELECTED_CENTER_TYPE:
        return { 
          ...state,
            [payload?.memberId] : {...state[payload?.memberId], selectedCenter: payload?.value}
          }
      case SET_ADDRESS_TYPE:
        return { 
          ...state,
            [payload?.memberId] : {...state[payload?.memberId], address: payload?.value}
          }
      case SET_EMAIL_TYPE:
        return { 
          ...state,
            [payload?.memberId] : {...state[payload?.memberId], email: payload?.value}
          }
      case SET_MOBILE_TYPE:
        return { 
          ...state,
            [payload?.memberId] : {...state[payload?.memberId], mobile: payload?.value}
          }
      case SET_CITY_TYPE:
        return { 
          ...state,
            [payload?.memberId] : {...state[payload?.memberId], city: payload?.value}
          }
      case SET_APPOINTMENT_DATE_TYPE:
        return { 
          ...state,
            [payload?.memberId] : {...state[payload?.memberId], appointmentDate: payload?.value}
          }
      case SET_APPOINTMENT_TIME_TYPE:
        return { 
          ...state,
            [payload?.memberId] : {...state[payload?.memberId], appointmentTime: payload?.value}
          }
      case SET_IS_MODAL_OPEN_TYPE:
        return { 
          ...state,
            [payload?.memberId] : {...state[payload?.memberId], isModalOpen: payload?.value}
          }
      case SET_ERROR_TYPE:
        return { 
          ...state,
            [payload?.memberId] : {...state[payload?.memberId], errors: {...state[payload?.memberId].errors, ...payload?.value}}
          }
      case RESET_FORM_TYPE:
        const {
          visitType,
          isPostalBtnEnable,
          includedMembers,
          pinCode,
          tpaDetails,
          showVisitType,
          isModalOpen,
        } = state?.[payload?.memberId] || {};
        return {
          ...state,
          [payload?.memberId]: {
            visitType,
            isPostalBtnEnable,
            includedMembers,
            pinCode,
            tpaDetails,
            showVisitType,
            isModalOpen,
            ...initialFormObj,
          },
        };
    case RESET_BOOK_RESPONSE:
      return { ...initialState }
    default:
      return state;
  }
};

export default bookVisitReducer;
